import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  const categoryLinks = [
    { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
    { name: "Hoodies/Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
    { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
    { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
    { name: "Pants/Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
    { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
    { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  ];

  const resourceLinks = [
    { label: "Kakobuy Spreadsheet", url: "https://kaspreadsheet.com", external: true },
    { label: "Poradnik bezpieczeństwa", url: "/artykul/poradnik-bezpieczenstwa-kakobuy", external: false },
    { label: "Przewodnik dla początkujących", url: "/artykul/przewodnik-poczatkujacy-kakobuy", external: false },
    { label: "Przewodnik wysyłki", url: "/artykul/przewodnik-wysylki-kakobuy-polska", external: false },
  ];

  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-foreground-950">
                Kakobuy<span className="text-primary-500">Sheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {t("footer.description")}
            </p>
            <p className="text-xs text-foreground-400">
              &copy; 2026 Kakobuy Spreadsheet Polska. {t("footer.copyright")}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              {t("footer.categories")}
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categoryLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              {t("footer.resources")}
            </h4>
            <ul className="flex flex-col gap-2.5">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.url}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
              <li>
                <Link
                  to="/artykul/kompletny-przewodnik-kakobuy-spreadsheet"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                >
                  Przewodnik Kakobuy Spreadsheet
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              {t("footer.legal")}
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <button className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Polityka prywatności
                </button>
              </li>
              <li>
                <button className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Regulamin
                </button>
              </li>
              <li>
                <button className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Kontakt
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}